module.exports = __webpack_public_path__ + "static/media/journey-hill.152b7555.svg";